import React, { useCallback, useEffect, useRef, useState } from "react";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../../../Store";
import { useBotConfigStore } from "../../../Store/Slices/ChatbotSlices/BotConfigSlice";
import {
  allMessagesStore,
  setAllMessages,
} from "../../../Store/Slices/socket/AllMessagesSlice";
import useMessagesData from "../../hooks/useMessagesData";
import AppSmallButton from "../UtilsComponents/AppSmallButton";

interface Props {}

const AppRenderStaticButtons: React.FC<Props> = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const dispatch = useAppDispatch();
  const { typingStatus, sessionId, allMessages, liveChatConnected } =
    useAppSelector(allMessagesStore);
  const { botConfig } = useSelector(useBotConfigStore);
  const [data, setData] = useState<any[]>([]);
  const { postBotUserQuery } = useMessagesData();

  const scrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (
      botConfig?.config?.quick_replies?.enabled &&
      botConfig?.config?.quick_replies?.data
    ) {
      setData(botConfig?.config?.quick_replies?.data);
    }
  }, [botConfig]);

  const handleOptionBtnClick = useCallback(
    (item: any) => {
      
      if (!item?.journey?.sub_flow?.nodeId) {
        console.warn("nodeId is empty wrong button format recieved", item);
        return;
      }

      if (!item?.journey?.sub_flow?.qid) {
        console.warn("qid is empty wrong button format recieved", item);
        return;
      }

      if (!item?.button_title) {
        console.warn("main_flow is empty wrong button format recieved", item);
        return;
      }

      let payload = {
        type: "text",
        value: item?.button_title,
        journey: {
          nodeId: item?.journey?.sub_flow?.nodeId,
          qid: item?.journey?.sub_flow?.qid,
          stage: item?.journey?.sub_flow?.stage ?? 0,
        },
        session_id: sessionId,
        isUser: true,
      };

      dispatch(setAllMessages([payload]));
      postBotUserQuery(payload);
    },
    [sessionId]
  ); //eslint-disable-line react-hooks/exhaustive-deps

  if (
    !botConfig?.config?.quick_replies?.enabled ||
    data?.length < 1 ||
    !allMessages ||
    allMessages.length === 0 ||
    liveChatConnected
  ) {
    return null;
  }

  return (
    <StyledWrapper>
      {data?.length > 2 && (
        <StyledScrollButton onClick={scrollLeft} direction="left">
          <ChevronLeftIcon />
        </StyledScrollButton>
      )}
      <StyledContainer ref={containerRef}>
        {data?.map((item: any, index) => {
          return (
            <AppSmallButton
              key={index.toString()}
              variant="primaryoutlinebutton"
              style={{
                whiteSpace: "nowrap",
                borderRadius: "8px",
                flexShrink: 0,
              }}
              onClick={() => typingStatus ? undefined : handleOptionBtnClick(item)}
            >
              {item?.button_title}
            </AppSmallButton>
          );
        })}
      </StyledContainer>
      {data?.length > 2 && (
        <StyledScrollButton onClick={scrollRight} direction="right">
          <ChevronRightIcon />
        </StyledScrollButton>
      )}
    </StyledWrapper>
  );
};

export default AppRenderStaticButtons;

const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

const StyledScrollButton = styled.button<{ direction: "left" | "right" }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${(props) => props.direction}: 4px;
  z-index: 10;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.1s ease;
  &:hover {
    background: rgba(0, 0, 0, 0.6);
  }

  &:active {
    transform: translateY(-50%) scale(0.95);
  }

  svg {
    font-size: 20px;
    color: #fff;
  }
`;

const StyledContainer = styled.div`
  && {
    width: 100%;
    overflow-y: hidden;
    overflow-x: auto;
    display: flex;
    align-items: center;
    padding: 8px 34px;
    gap: 14px;

    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;

    -ms-overflow-style: none;
  }
`;
